import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PermissionRouteProps {
    modul: string;
    children: React.ReactNode;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ modul, children }) => {
    const { hasPermission } = useAuth();

    if (!hasPermission(modul)) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default PermissionRoute;
